
import { Row, Col } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip } from 'react-bootstrap';
import './CampaignStyles.css'
import { templates } from '../Misc/Templates';
import './CampaignGrid.css'


export function TempGrid({template, selectFunc, selected, hoverFunc, products, page, activeGrids}) {
    if (!(template.includes("QUARTER"))) {
        return (
            <div>{templates[template].map((row, index) => {return (
                <Row key={index}>
                    {row.map((block) => {return (
                        <Col xs={block.width} className="col_square border border-dark"
                        style={{
                        backgroundColor: selected===block.id ? '#a73c21' : (`${page}page${block.id}` in products && products[`${page}page${block.id}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes'
                        ? '#4a4a4a'
                        : '#dedede'),
                        aspectRatio: block.shape === 'standard' ? 1/1 : 2/1,
                        display: "block"
                        }}
                        id={block.id}
                        key={block.id}>
                        
                        <OverlayTrigger
                            overlay={
                                !(`${page}page${block.id}` in products && products[`${page}page${block.id}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes') ? (hoverFunc(block.id)) : <span></span>}
                            //overlay={<p>hello</p>}
                            delay={
                            { show: 250, hide: 250 }
                        }>
                        
                    <p className='grid_link text-wrap' style={{lineHeight: "100%",      overflow: "hidden",
                            color: (`${page}page${block.id}` in products && products[`${page}page${block.id}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes'
                                ? '#d9d9d9'
                                : '#000000')
                        }} onClick={() => {selectFunc(block.id);console.log(`${selected}, ${block.id}`)}} id={`${block.id}name`}>
                        {`${page}page${block.id}` in products
                        ?
                        (products[`${page}page${block.id}`]['name'] !== ""
                            ? products[`${page}page${block.id}`]['name']
                            : "MISSING PRINT NAME"
                        )
                        : "Select Box"}
                    </p>
                </OverlayTrigger>
            </Col>
            )
        })} 
        </Row>
        )})}
        </div>
        );
    } else if (template.includes("1_1")) {
        return(
        <div>
            {(template === "FLYER-QUARTER_1_1_LEFT") ? (
                <Row>
                    <GridCell block={templates[template][0][0]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                    <Col>
                    <Row>
                    <GridCell block={templates[template][0][1]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                    </Row>
                    <Row>
                    <GridCell block={templates[template][0][2]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                    </Row>
                    </Col>
                </Row>
            )
            : (
                <Row> 
                    <Col>
                    <Row>
                    <GridCell block={templates[template][0][0]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                    </Row>
                    <Row>
                    <GridCell block={templates[template][0][1]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                    </Row>
                    </Col>
                    <GridCell block={templates[template][0][2]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                </Row>
            )}
                
            <Row>
                {templates[template][1].map((block, index) => {return (
                    <GridCell key={index} block={block} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page}/>
                );
                })}
            </Row>
            <Row>
                {templates[template][2].map((block, index) => {return (
                    <GridCell key={index} block={block} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page}/>
                );
                })}
            </Row>

        </div>
        );
    } else {
        return(
            <div>
                {(template === "FLYER-QUARTER_2_2_LEFT") ? (
                    <Row>
                        <GridCell block={templates[template][0][0]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                        <Col>
                        <Row>
                        <GridCell block={templates[template][0][1]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                        <GridCell block={templates[template][0][2]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                        </Row>
                        <Row>
                        <GridCell block={templates[template][0][3]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                        <GridCell block={templates[template][0][4]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                        </Row>
                        </Col>
                    </Row>
                )
                : (
                    <Row> 
                        <Col>
                        <Row>
                            <GridCell block={templates[template][0][0]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                            <GridCell block={templates[template][0][1]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                        </Row>
                        <Row>
                            <GridCell block={templates[template][0][2]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                            <GridCell block={templates[template][0][3]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                        
                        </Row>
                        </Col>
                        <GridCell block={templates[template][0][4]} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page} />
                    </Row>
                )}
                    
                <Row>
                    {templates[template][1].map((block, index) => {return (
                        <GridCell key={index} block={block} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page}/>
                    );
                    })}
                </Row>
                <Row>
                    {templates[template][2].map((block, index) => {return (
                        <GridCell key={index} block={block} selectFunc={selectFunc} hoverFunc={hoverFunc} selected={selected} products={products} page={page}/>
                    );
                    })}
                </Row>
    
            </div>
            );
    }
}

export function GridCell({block, selectFunc, hoverFunc, products, page, selected}) {

    //style={{backgroundColor: selected===block.id ? '#a73c21' : (`${page}page${block.id}` in products && products[`${page}page${block.id}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes' ? '#4a4a4a' : '#dedede')
    let backgroundColor = '#dedede'; // default
    if (selected === block.id) {
        backgroundColor = '#a73c21';
    } else if (`${page}page${block.id}` in products && products[`${page}page${block.id}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes') {
        backgroundColor = '#4a4a4a';
    }/* else if (hasOtherUsers) {
        backgroundColor = '#e3f2fd'; // Light blue for active users
    }*/

    return (
    <Col xs={block.width} className="col_square border border-dark" style={{backgroundColor: backgroundColor,
    aspectRatio: block.shape === 'standard' ? 1/1 : 2/1}} id={block.id} key={block.id}>
        <OverlayTrigger
        overlay={!(`${page}page${block.id}` in products && products[`${page}page${block.id}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes') ? (hoverFunc(block.id)) : <span></span>}
        //overlay={console.log('hello')}
        //overlay={<p>hello</p>}
        delay={{ show: 250, hide: 250 }}>
        <p className='grid_link' onClick={() => {selectFunc(block.id);console.log(`${selected}, ${block.id}`)}} id={`${block.id}name`}
        style={{lineHeight: "100%",
            overflow: "hidden",
            color: 
            (`${page}page${block.id}` in products && products[`${page}page${block.id}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes'
            ? '#d9d9d9'
            : '#000000')}}>
        {`${page}page${block.id}` in products
        ? (products[`${page}page${block.id}`]['name'] !== ""
                    ? products[`${page}page${block.id}`]['name']
                    : "MISSING PRINT NAME"
                )
                : "Select Box"}
            </p>
        </OverlayTrigger>
    </Col>);
}
 
export default TempGrid;